import { responsiveFontSizes, adaptV4Theme } from "@mui/material/styles";
import { createTheme } from '@mui/material/styles'
import variants from "./variants";
import typography from "./typography";
import overrides from "./overrides";
import breakpoints from "./breakpoints";
import props from "./props";
import shadows from "./shadows";

const createMuiTheme = (name) => {
    let themeConfig = variants.find((variant) => variant.name === name);

    if (!themeConfig) {
        console.warn(new Error(`The theme ${name} is not valid`));
        themeConfig = variants[0];
    }

    return responsiveFontSizes(createTheme({
        spacing: 4,
        breakpoints: breakpoints,
        overrides: overrides,
        props: props,
        typography: typography,
        shadows: shadows,
        palette: themeConfig.palette,
        components: themeConfig.name === "HOSPITAL" ? {
            MuiButton: {
                styleOverrides: {
                    containedPrimary: {
                        backgroundColor: "#287B72",
                        "&:hover": {
                            backgroundColor: "#0F8678",
                        },
                    },
                    outlinedPrimary: {
                        borderColor: "#287B72",
                        color: "#287B72",
                        "&:hover": {
                            borderColor: "#0F8678",
                            backgroundColor: "rgba(40, 123, 114, 0.08)",
                        },
                    },
                },
            },
        } : {},
        buttonContinue : {
            primary: {
                background : themeConfig.name === "HOSPITAL" ? "#287B72" : "#48bb78",
                color : "#FFF"
            },
            secondary: {
                background : "#ccc",
                color : "#FFF"
            }
            
        },
        buttonCancel: {
            background : "#e53e3e",
            color : "#FFF"
        },
        buttonOther: {
            background : "goldenrod",
            color : "#FFF"
        },
        error : {
            color : "#e53e3e",
        },
        edit : {
            color : "#81e6d9",
        },
        primary : {
            background : themeConfig.name === "HOSPITAL" ? "#287B72" : "#35887D",
            color : "#FFF",
        },
        name: themeConfig.name,
        header: themeConfig.header,
        footer: themeConfig.footer,
        sidebar: themeConfig.sidebar,
    }));
};

export default createMuiTheme;
